export default {
  verifying: 'Verifying address...'
}



// WEBPACK FOOTER //
// ./src/App/i18n/strings/auth/verifyEmail/en.js